@if (visible) {
  <button
    class="onboarding-fab"
    [class.fab-active]="open"
    (click)="toggle()"
    matTooltip="Finish setting up"
    matTooltipPosition="left"
    aria-label="Onboarding setup"
  >
    <span class="fab-badge">{{ doneCount }}/{{ items.length }}</span>
    <mat-icon>rocket_launch</mat-icon>
  </button>

  @if (open) {
    <div class="sheet-backdrop" (click)="toggle()"></div>
    <div class="onboarding-sheet">
      <div class="sheet-header">
        <div class="sheet-title-group">
          <mat-icon class="sheet-title-icon">school</mat-icon>
          <div>
            <h3 class="sheet-title">Finish setting up</h3>
            <p class="sheet-sub">{{ doneCount }} of {{ items.length }} steps done</p>
          </div>
        </div>
        <button class="sheet-close" (click)="toggle()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="(doneCount / items.length) * 100"></div>
      </div>

      <ul class="checklist">
        @for (item of items; track item.id) {
          <li
            class="checklist-item"
            [class.done]="item.status === 'done'"
            [class.skipped]="item.status === 'skipped'"
          >
            @if (item.status === 'done') {
              <mat-icon class="item-icon item-done">check_circle</mat-icon>
            } @else if (item.status === 'skipped') {
              <mat-icon class="item-icon item-skipped">remove_circle_outline</mat-icon>
            } @else {
              <mat-icon class="item-icon item-pending">{{ item.icon }}</mat-icon>
            }
            <span class="item-label">{{ item.label }}</span>
          </li>
        }
      </ul>

      <button mat-raised-button class="resume-btn" (click)="resume()">
        Resume setup
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>
    </div>
  }
}
